export default __webpack_public_path__ + "static/media/Validar-Afiliado.fd339df5.pdf";